import { render, staticRenderFns } from "./CragGuidesCard.vue?vue&type=template&id=f1ffd9d4"
import script from "./CragGuidesCard.vue?vue&type=script&lang=js"
export * from "./CragGuidesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports